import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle, CircleAlert, XCircle } from "lucide-react";
import { Button } from "@mui/material";
import { Formik,Form } from "formik";
import { activateSender } from "../../requests/Sender_Ids/SenderService";

const ActivateSenderModal = ({ isOpen, onClose, onSuccess, onError,sender,senderId, type }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/60 z-[999] backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            className="fixed inset-0 z-[1000] overflow-y-auto"
          >
            <Formik
              initialValues={{
                // senderId: sender?.sender_slug || "",
                status: "Approved",
                sender: sender?.sender || "",
              }}
              onSubmit={(values, actions) =>
                activateSender(values,senderId, { ...actions, onClose, onSuccess,onError })
              }
            >
              {({ isSubmitting, touched, errors, values }) => (
                <Form>
                  <div className="flex min-h-screen items-center justify-center p-4">
                    <div className="w-full max-w-md">
                      <motion.div
                        className="bg-white rounded-3xl shadow-[0_20px_70px_-10px_rgba(0,0,0,0.3)] overflow-hidden"
                        layoutId="modal-container"
                      >
                        {/* Status Bar */}
                        <motion.div
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          className="w-full h-1.5 bg-gray-100"
                        >
                          <motion.div
                            initial={{ width: 0 }}
                            animate={{ width: "100%" }}
                            transition={{ duration: 1 }}
                            className="h-full bg-green-500"
                          />
                        </motion.div>

                        {/* Content */}
                        <div className="px-8 pt-6 pb-8">
                          <div className="flex flex-col items-center text-center">
                            <motion.div
                              initial={{ scale: 0 }}
                              animate={{ scale: 1 }}
                              transition={{
                                type: "spring",
                                stiffness: 400,
                                damping: 25,
                              }}
                              className="bg-green-50 p-4 rounded-full mb-4"
                            >
                              {isSubmitting ? (
                                <>
                                  <div className="relative inset-0 flex items-center justify-center">
                                    <div className="w-6 h-6 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
                                  </div>
                                </>
                              ) : ( onSuccess ? (
                                 <CircleAlert
                                  className="h-10 w-10 text-green-500"
                                  strokeWidth={2.5}
                                />
                              ) : ""
                               
                              )}
                            </motion.div>

                            <h2 className="text-2xl font-bold text-gray-900 mb-2">
                              {type === "active"
                                ? "Sender ID Approval"
                                : " Sender ID Activation"}
                            </h2>
                            <p className="text-gray-600 text-lg">
                              Your are about to{" "}
                              {type === "active" ? "Approve" : "Activate"}{" "}
                              <span className="font-bold"> {sender.sender}</span> as
                              Sender Id for {sender.brand_name} 
                            </p>
                          </div>
                        </div>

                        {/* Footer */}
                        <div className="px-8 gap-4 py-4 bg-gray-50 flex justify-end">
                          <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={onClose}
                            className="px-6 py-2.5 text-sm font-semibold text-white bg-gray-900 
                                rounded-xl hover:bg-gray-800 transition-all duration-200"
                          >
                            Cancel
                          </motion.button>
                          <motion.button
                            type="submit"
                            disabled={isSubmitting}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            className="px-6 py-2.5 text-sm font-semibold text-white bg-green-500 
                                rounded-xl hover:bg-green-600 transition-all duration-200"
                          >
                            {type === "active" ? "Approve" : "Activate"}
                          </motion.button>
                        </div>
                      </motion.div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ActivateSenderModal;
